import { render, staticRenderFns } from "./TenderCardCompaniesInfo.vue?vue&type=template&id=2cf453bb&"
import script from "./TenderCardCompaniesInfo.vue?vue&type=script&lang=js&"
export * from "./TenderCardCompaniesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports